"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONCEPTS = exports.CONCEPT = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../../fragments");
exports.CONCEPT = (0, client_1.gql) `
  ${fragments_1.CHAPTER_FIELDS}
  query Concept($id: Int!) {
    restricted {
      concept(id: $id) {
        id
        name
        status
        totalCards
        entitlement {
          id
          name
        }
        topic {
          id
          name
          typeId
          entitlement {
            id
            name
          }
        }
        userNote {
          id
          userId
          conceptId
          note
          updatedAt
        }
        userChapter {
          id
          userId
          conceptId
          explanation
          updatedAt
        }
        chapter {
          ...ChapterFields
        }
        videos {
          id
          status
          title
          museId
          startTime
          endTime
          thumbnail
          concepts {
            id
            name
          }
          live
          description
          duration
        }
      }
    }
  }
`;
exports.CONCEPTS = (0, client_1.gql) `
  query Concepts($id: [Int!]!) {
    restricted {
      concepts(id: $id) {
        id
        name
        status
        totalCards
        entitlement {
          id
          name
        }
        topic {
          id
          name
          typeId
        }
        chapter {
          ...ChapterFields
        }
        userNote {
          id
          userId
          conceptId
          note
          updatedAt
        }
        userChapter {
          id
          userId
          conceptId
          explanation
          updatedAt
        }
        videos {
          id
          status
          title
          museId
          startTime
          endTime
          thumbnail
          concepts {
            id
            name
          }
          live
          description
          duration
        }
      }
    }
  }
`;
